module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ1_4.161d3fe1.svg";